import { render, staticRenderFns } from "./SingleDetails.vue?vue&type=template&id=de24aed6&lang=pug&"
import script from "./SingleDetails.vue?vue&type=script&lang=js&"
export * from "./SingleDetails.vue?vue&type=script&lang=js&"
import style0 from "./SingleDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports